









import Vue from 'vue';
import { ProductAccessClient } from '@/assets/src/clients/product_access_client';

export default Vue.extend({
  name: 'ProductList',

  props: {
    value: String,
  },

  watch: {
    productType() {
      this.$emit('input', this.productType);
    },
  },

  methods: {
    async fetchProductTypes() {
      if (!this.productAccessClient) {
        return;
      }

      this.productTypes = await this.productAccessClient.getProductTypes();
      this.productType = this.productTypes[0];
    },
  },

  mounted() {
    this.productAccessClient = new ProductAccessClient();
    this.fetchProductTypes();
  },

  data() {
    return {
      productType: '' as string,
      productTypes: [] as string[],
      productAccessClient: null as ProductAccessClient | null,
    };
  },
});
